import { render, staticRenderFns } from "./ProjectComponent.vue?vue&type=template&id=50bbdd2e&scoped=true"
import script from "./ProjectComponent.vue?vue&type=script&lang=js"
export * from "./ProjectComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectComponent.vue?vue&type=style&index=0&id=50bbdd2e&prod&lang=css"
import style1 from "./ProjectComponent.vue?vue&type=style&index=1&id=50bbdd2e&prod&lang=scss"
import style2 from "./ProjectComponent.vue?vue&type=style&index=2&id=50bbdd2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bbdd2e",
  null
  
)

export default component.exports